export default "__VITE_ASSET__BVDS6l_J__"